import React, { useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import apiPublico from '../../services/apiPublico';
import s from '../Loja.module.css';

// Conta do comprador de curso — totalmente separada do login de funcionário
// (backend/src/middlewares/authComprador.js). Token fica no localStorage
// numa chave por loja (o mesmo navegador pode logar em lojas diferentes).
export function chaveTokenComprador(slug) { return `comprador_token_${slug}`; }

export default function LoginComprador() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  const entrar = async (e) => {
    e.preventDefault();
    setErro(''); setCarregando(true);
    try {
      const { data } = await apiPublico.post(`/catalogo/${slug}/auth/login`, { email, senha });
      localStorage.setItem(chaveTokenComprador(slug), data.token);
      navigate(params.get('voltar') || `/loja/${slug}`, { replace: true });
    } catch (err) {
      setErro(err.response?.data?.erro || 'E-mail ou senha inválidos.');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className={s.pagina} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <form onSubmit={entrar} style={{ background: '#fff', borderRadius: 10, padding: 28, width: 380, maxWidth: '92vw', boxShadow: '0 8px 40px rgba(0,0,0,0.15)' }}>
        <h2 style={{ margin: '0 0 6px' }}>Entrar</h2>
        <p style={{ margin: '0 0 18px', fontSize: 13, color: '#666' }}>
          Use o e-mail e a senha que você criou na hora da compra.
        </p>
        <div className={s.campoCheckout}>
          <label>E-mail</label>
          <input type="email" className={s.inputCheckout} value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
        </div>
        <div className={s.campoCheckout}>
          <label>Senha</label>
          <input type="password" className={s.inputCheckout} value={senha} onChange={e => setSenha(e.target.value)} required />
        </div>
        {erro && <div className={s.erroCheckout}>{erro}</div>}
        <button type="submit" className={s.btnPagar} disabled={carregando} style={{ width: '100%', marginTop: 8 }}>
          {carregando ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
